function getCookie (name) {
  const value = '; ' + document.cookie
  const parts = value.split('; ' + name + '=')
  if (parts.length === 2) {
    return parts.pop().split(';').shift()
  }
  return null
}

const endpoints = {
  fetch_csrf_token () {
    return '/api/v1/csrf'
  },
  fetch_sentry_config () {
    return '/api/v1/sentry'
  },
  fetch_user (id) {
    return `/api/v1/users/${id}/`
  },
  fetch_employee (id) {
    if (!id) {
      return `/api/v1/employees/`
    } else {
      return `/api/v1/employees/${id}/`
    }
  },
  fetch_place () {
    return '/api/v1/places/'
  },
  fetch_profile (id) {
    if (id) {
      return `/api/v1/profiles/${id}/`
    } else {
      return '/api/v1/profiles/'
    }
  },
  fetch_log (id) {
    if (id) {
      return `/api/v1/logs/${id}/`
    } else {
      return '/api/v1/logs/'
    }
  },
  fetch_pivot () {
    return '/api/v1/pivot/'
  },
  fetch_details () {
    return 'api/v1/details/'
  },
  create_operation () {
    return "/api/v1/operations/"
  },
  update_operation (id) {
    return `/api/v1/operations/${id}/`
  },
  delete_operation (id) {
    return `/api/v1/operations/${id}/`
  },
  fetch_operation (id) {
    if (id) {
      return `/api/v1/operations/${id}/`
    } else {
      return "/api/v1/operations/"
    }
  },
  fetch_project (id) {
    if (id) {
      return `/api/v1/projects/${id}/`
    } else {
      return `/api/v1/projects/`
    }
  },
  create_project () {
    return `/api/v1/projects/`
  },
  update_project (id) {
    return `/api/v1/projects/${id}/`
  },
  delete_project (id) {
    return `/api/v1/projects/${id}/`
  },
  fetch_tenants () {
    return "/api/v1/tenants/"
  },
  fetch_tenant (id) {
    return `/api/v1/tenants/${id}/`
  },
  update_employee (id) {
    return `/api/v1/employees/${id}/`
  },
  delete_employee (id) {
    return `/api/v1/employees/${id}/`
  },
  create_employee () {
    return '/api/v1/employees/'
  },
  fetch_timeclock (id) {
    if (id) {
      return `/api/v1/timeclock/${id}/`
    } else {
      return `/api/v1/timeclock/`
    }
  },
  create_timeclock () {
    return `/api/v1/timeclock/`
  },
  update_timeclock (id) {
    return `/api/v1/timeclock/${id}/`
  },
  delete_timeclock (id) {
    return `/api/v1/timeclock/${id}/`
  },
  fetch_employee_quicksums (id) {
    return '/api/v1/quicksum/employees/'
  },
  fetch_project_quicksums (id) {
    return '/api/v1/quicksum/projects/'
  },
  login () {
    return '/api/v1/login'
  },
  probeLogin () {
    return '/api/v1/probe-login'
  },
  checkLoginTenant () {
    return '/api/v1/check-tenant-identifier'
  },
  logout () {
    return '/api/v1/logout'
  }
}

for (let [e, f] of Object.entries(endpoints)) {
  endpoints[e] = function () {
    return {
      earmarked: 1,
      url: f(...arguments),
    }
  }
}

class UnknownEndpointError extends Error {
  constructor () {
    super('Unknown endpoint')
  }
}

class InvalidRequestError extends Error {
  constructor (code, response) {
    super('Request resulted in an error.')
    this.code = code
    this.response = response
  }
}

function _needsCsrfToken (method) {
  switch (method.toLowerCase()) {
    case 'head':
    case 'get':
    case 'options':
      // make absolutely sure these methods do not alter data
      return false
    default:
      return true
  }
}

async function api (endpoint, data, options) {
  if (!endpoint.earmarked) {
    throw new UnknownEndpointError()
  }

  let url = endpoint.url
  const fetchOptions = options || {}
  fetchOptions.credentials = fetchOptions.credentials || 'same-origin'
  fetchOptions.headers = fetchOptions.headers || {}

  fetchOptions.headers["Accept"] = fetchOptions.headers["Accept"] || "application/json"

  if (data) {
    fetchOptions.method = fetchOptions.method || 'POST'

    if (!fetchOptions.body && fetchOptions.method.toLowerCase() !== 'head' && fetchOptions.method.toLowerCase() !== 'get') {
      fetchOptions.body = JSON.stringify(data)
      fetchOptions.headers['Content-Type'] = fetchOptions['Content-Type'] || 'application/json'
    } else if (Object.keys(data).length > 0) {
      url += '?' + Object.entries(data).map(([k, v]) => `${encodeURI(k)}=${encodeURI(v)}`).join('&')
    }
  }
  fetchOptions.method = fetchOptions.method || 'GET'

  fetchOptions.needsCsrfToken = fetchOptions.needsCsrfToken || _needsCsrfToken(fetchOptions.method)
  let csrf = getCookie('csrftoken')
  if (!csrf) {
    if (fetchOptions.needsCsrfToken) {
      await api(endpoints.fetch_csrf_token())
      csrf = getCookie('csrftoken')
    }
  }
  if (fetchOptions.needsCsrfToken && csrf) {
    fetchOptions.headers['X-CSRFToken'] = csrf
  }
  return fetch(url, fetchOptions)
}

export { api, endpoints, InvalidRequestError }
